<template>
    <v-container grid-list-lg>
        <h1 class="display-1 mb-1">
            Product Return Wizard
        </h1>
        <v-layout
            row
            wrap
        >
            <v-flex
                xs12
                sm8
            >
                <v-layout
                    row
                    wrap
                    mb-2
                >
                    <v-spacer />
                    <v-flex
                        xs6
                        md3
                    >
                        <v-btn
                            class="my-0"
                            flat
                            block
                            @click="onBack"
                        >
                            Back to Results
                        </v-btn>
                    </v-flex>
                </v-layout>
                <return-wizard
                    :is-edit="isEdit"
                    :invoice="invoice"
                    :product-return="productReturn"
                    @dialog-back="onBack"
                    @created="onCreate"
                    @updated="onUpdate"
                />
            </v-flex>
            <v-flex
                xs12
                sm4
            >
                <invoice-card :invoice="invoiceCardData" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import InvoiceCard from '../../components/InvoiceCard'
import ReturnWizard from '../../components/ReturnWizard'

export default {
    components: {
        InvoiceCard,
        ReturnWizard
    },
    props: {
        // // only required for add wizard
        // // invoice data is pulled from product return for edit wizard
        invoice: {
            type: Object,
            default: () => {}
        },
        invoiceCardData: {
            type: Object,
            required: true
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        // only required for edit wizard
        productReturn: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        onBack () {
            this.$emit('back')
        },
        onCreate (productReturn) {
            this.$emit('created', productReturn)
        },
        onUpdate (productReturn) {
            this.$emit('updated', productReturn)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
